import { apiCommodityCommodityBatchRewardBySku } from '@/api'

export async function getManyGoodsBonus(skus) {
  const res = await apiCommodityCommodityBatchRewardBySku({
    skuList: skus.map(sku => ({
      skuId: sku.skuId,
      skuAmount: sku.count,
      salePrice:
        sku.commoditySkuPrice ||
        /* 兼容预下单返回的 */ sku.unitPrice ||
        /* 兼容秒杀 */ sku.originalPrice,
      serviceType: '49',
      unitOrgCode: '49360100',
    })),
  })
  return res.reduce((res, item) => {
    res[item.skuId] = item.rewardList
      .map(item => `${item.rewardAmount}${item.rewardName}`)
      .join('+')
    return res
  }, {})
}

export async function getGoodsBonus(sku, count) {
  return getManyGoodsBonus([
    {
      ...sku,
      count: count,
    },
  ]).then(res => res[sku.skuId])
}
